import { APP_INITIALIZER, Provider } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap, timeout } from 'rxjs/operators';
import { ClientConfigDataService } from '@core/data/api/config/client-config-data.service';

/**
 * Fetches GET /v3/client-config at app bootstrap so the Intercom app_id is
 * available by the time the session boots Intercom.
 *
 * Fire-and-forget: the factory does not return the promise, so bootstrap is
 * never blocked. On failure (or timeout) the config is cleared and Intercom
 * falls back to environment.intercom.app_id.
 */
export function clientConfigInitializerFactory(svc: ClientConfigDataService): () => void {
    return () => {
        svc.fetchConfig()
            .pipe(
                timeout(5000),
                tap((config) => svc.setConfig(config)),
                catchError((err) => {
                    console.warn(
                        '[client-config] Failed to fetch — Intercom will use environment fallback',
                        err,
                    );
                    svc.setConfig(null);
                    return of(null);
                }),
            )
            .subscribe();
    };
}

export const CLIENT_CONFIG_INITIALIZER_PROVIDER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: clientConfigInitializerFactory,
    deps: [ClientConfigDataService],
    multi: true,
};
